import { arkaTenantBlueprint } from "@/components/atomic-crm/root/arkaTenantBlueprint";
import { naiuTenantBlueprint } from "@/components/atomic-crm/root/naiuTenantBlueprint";
import type { TenantBlueprint } from "@/components/atomic-crm/root/arkaTenantBlueprint";

export type ArkaTenantId = "arka" | "naiu";

export function getArkaTenantId(): ArkaTenantId {
  return import.meta.env.VITE_ARKA_TENANT === "naiu" ? "naiu" : "arka";
}

export function isNaiuTenant(): boolean {
  return getArkaTenantId() === "naiu";
}

export function getActiveBlueprint(): TenantBlueprint {
  return isNaiuTenant() ? naiuTenantBlueprint : arkaTenantBlueprint;
}
